/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				d="M2 4V15.6C2 17.8402 2 18.9603 2.43597 19.816C2.81947 20.5686 3.43139 21.1805 4.18404 21.564C5.03968 22 6.15979 22 8.4 22H15.6C17.8402 22 18.9603 22 19.816 21.564C20.5686 21.1805 21.1805 20.5686 21.564 19.816C22 18.9603 22 17.8402 22 15.6V12.4C22 10.1598 22 9.03968 21.564 8.18404C21.1805 7.43139 20.5686 6.81947 19.816 6.43597C18.9603 6 17.8402 6 15.6 6H12M17 6L15.92 4.56C15.216 3.62134 14.864 3.15201 14.4179 2.8135C14.0228 2.5137 13.5754 2.28999 13.0985 2.15378C12.56 2 11.9733 2 10.8 2H4C2.89543 2 2 2.89543 2 4V4C2 5.10457 2.89543 6 4 6H17Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M22 11H21.5C19.8431 11 18.5 12.3431 18.5 14V14C18.5 15.6569 19.8431 17 21.5 17H22M7.5 14H10H12.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M22 11C22 10.0707 22 9.60603 21.9231 9.21964C21.6075 7.63288 20.3671 6.39249 18.7804 6.07686C18.394 6 17.9293 6 17 6H2V15.6C2 17.8402 2 18.9603 2.43597 19.816C2.81947 20.5686 3.43139 21.1805 4.18404 21.564C5.03969 22 6.15979 22 8.4 22H17C17.9293 22 18.394 22 18.7804 21.9231C20.3671 21.6075 21.6075 20.3671 21.9231 18.7804C22 18.394 22 17.9293 22 17H21C19.3431 17 18 15.6569 18 14C18 12.3431 19.3431 11 21 11H22Z"
				fill="currentColor"
			/>
			<path
				d="M2 4V15.6C2 17.8402 2 18.9603 2.43597 19.816C2.81947 20.5686 3.43139 21.1805 4.18404 21.564C5.03968 22 6.15979 22 8.4 22H15.6C17.8402 22 18.9603 22 19.816 21.564C20.5686 21.1805 21.1805 20.5686 21.564 19.816C22 18.9603 22 17.8402 22 15.6V12.4C22 10.1598 22 9.03968 21.564 8.18404C21.1805 7.43139 20.5686 6.81947 19.816 6.43597C18.9603 6 17.8402 6 15.6 6H12M22 11H21.5C19.8431 11 18.5 12.3431 18.5 14V14C18.5 15.6569 19.8431 17 21.5 17H22M7.5 14H10H12.5M17 6L15.92 4.56C15.216 3.62134 14.864 3.15201 14.4179 2.8135C14.0228 2.5137 13.5754 2.28999 13.0985 2.15378C12.56 2 11.9733 2 10.8 2H4C2.89543 2 2 2.89543 2 4V4C2 5.10457 2.89543 6 4 6H17Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.25 4.00003C1.25 3.99963 1.25 3.99919 1.25 3.99879C1.25067 2.48058 2.48163 1.25003 4 1.25003L10.9131 1.25001C11.9779 1.2498 12.6637 1.24966 13.3044 1.43265C13.8708 1.59439 14.4021 1.86004 14.8713 2.21607C15.4021 2.61886 15.8134 3.16757 16.4521 4.01949L17.3845 5.26274C17.7141 5.271 18.0141 5.28459 18.2883 5.30699C19.0017 5.36527 19.6053 5.48688 20.1565 5.76772C21.0502 6.22312 21.7769 6.94978 22.2323 7.84355C22.5131 8.39472 22.6347 8.99835 22.693 9.71173C22.7068 9.88099 22.7173 10.0601 22.7252 10.25H21C18.9289 10.25 17.25 11.9289 17.25 14C17.25 16.0711 18.9289 17.75 21 17.75H22.7252C22.7173 17.9399 22.7068 18.119 22.693 18.2883C22.6347 19.0017 22.5131 19.6053 22.2323 20.1565C21.7769 21.0502 21.0502 21.7769 20.1565 22.2323C19.6053 22.5131 19.0017 22.6347 18.2883 22.693C17.5906 22.75 16.7252 22.75 15.633 22.75H8.36698C7.27485 22.75 6.40935 22.75 5.71173 22.693C4.99834 22.6347 4.39472 22.5131 3.84355 22.2323C2.94978 21.7769 2.22312 21.0502 1.76772 20.1565C1.48688 19.6053 1.36527 19.0017 1.30699 18.2883C1.24999 17.5906 1.24999 16.7252 1.25 15.633V4.00003ZM12.8925 2.87498C12.4787 2.75681 12.0168 2.75003 10.8 2.75003H4C3.30964 2.75003 2.75 3.30967 2.75 4.00003C2.75 4.68746 3.30492 5.24529 3.99124 5.25H15.5L15.32 5.01003C14.5899 4.03659 14.3073 3.67112 13.9645 3.411C13.6435 3.16741 13.28 2.98564 12.8925 2.87498ZM7.5 13.25C7.08579 13.25 6.75 13.5858 6.75 14C6.75 14.4142 7.08579 14.75 7.5 14.75H12.5C12.9142 14.75 13.25 14.4142 13.25 14C13.25 13.5858 12.9142 13.25 12.5 13.25H7.5Z"
				fill="currentColor"
			/>
			<path
				d="M22.75 15.6359C22.75 15.8491 22.75 16.0536 22.7496 16.25H21C19.7574 16.25 18.75 15.2426 18.75 14C18.75 12.7574 19.7574 11.75 21 11.75H22.7496C22.75 11.9464 22.75 12.1509 22.75 12.3641V15.6359Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M12 6H15.6C17.8402 6 18.9603 6 19.816 6.43597C20.5686 6.81947 21.1805 7.43139 21.564 8.18404C22 9.03968 22 10.1598 22 12.4V15.6C22 17.8402 22 18.9603 21.564 19.816C21.1805 20.5686 20.5686 21.1805 19.816 21.564C18.9603 22 17.8402 22 15.6 22H8.4C6.15979 22 5.03968 22 4.18404 21.564C3.43139 21.1805 2.81947 20.5686 2.43597 19.816C2 18.9603 2 17.8402 2 15.6V9M22 11H21.5C19.8431 11 18.5 12.3431 18.5 14V14C18.5 15.6569 19.8431 17 21.5 17H22M7.5 14H10H12.5M17 6L15.92 4.56C15.216 3.62134 14.864 3.15201 14.4179 2.8135C14.0228 2.5137 13.5754 2.28999 13.0985 2.15378C12.56 2 11.9733 2 10.8 2H4C2.89543 2 2 2.89543 2 4V4C2 5.10457 2.89543 6 4 6H17Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M2 4V15.6C2 17.8402 2 18.9603 2.43597 19.816C2.81947 20.5686 3.43139 21.1805 4.18404 21.564C5.03968 22 6.15979 22 8.4 22H15.6C17.8402 22 18.9603 22 19.816 21.564C20.5686 21.1805 21.1805 20.5686 21.564 19.816C22 18.9603 22 17.8402 22 15.6V12.4C22 10.1598 22 9.03968 21.564 8.18404C21.1805 7.43139 20.5686 6.81947 19.816 6.43597C18.9603 6 17.8402 6 15.6 6H12M22 11H21.5C19.8431 11 18.5 12.3431 18.5 14V14C18.5 15.6569 19.8431 17 21.5 17H22M7.5 14H10H12.5M17 6L15.92 4.56C15.216 3.62134 14.864 3.15201 14.4179 2.8135C14.0228 2.5137 13.5754 2.28999 13.0985 2.15378C12.56 2 11.9733 2 10.8 2H4C2.89543 2 2 2.89543 2 4V4C2 5.10457 2.89543 6 4 6H17Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.25 4.00003L1.25 3.99879C1.25067 2.48058 2.48163 1.25003 4 1.25003L10.9131 1.25001C11.9779 1.2498 12.6637 1.24966 13.3044 1.43265C13.8708 1.59439 14.4021 1.86004 14.8713 2.21607C15.4021 2.61886 15.8134 3.16757 16.4521 4.01949L17.3845 5.26274C17.7141 5.271 18.0141 5.28459 18.2883 5.30699C19.0017 5.36527 19.6053 5.48688 20.1565 5.76772C21.0502 6.22312 21.7769 6.94978 22.2323 7.84355C22.5131 8.39472 22.6347 8.99835 22.693 9.71173C22.7068 9.88099 22.7173 10.0601 22.7252 10.25H21C18.9289 10.25 17.25 11.9289 17.25 14C17.25 16.0711 18.9289 17.75 21 17.75H22.7252C22.7173 17.9399 22.7068 18.119 22.693 18.2883C22.6347 19.0017 22.5131 19.6053 22.2323 20.1565C21.7769 21.0502 21.0502 21.7769 20.1565 22.2323C19.6053 22.5131 19.0017 22.6347 18.2883 22.693C17.5906 22.75 16.7252 22.75 15.633 22.75H8.36698C7.27485 22.75 6.40935 22.75 5.71173 22.693C4.99834 22.6347 4.39472 22.5131 3.84355 22.2323C2.94978 21.7769 2.22312 21.0502 1.76772 20.1565C1.48688 19.6053 1.36527 19.0017 1.30699 18.2883C1.24999 17.5906 1.24999 16.7252 1.25 15.633V4.00003ZM12.8925 2.87498C12.4787 2.75681 12.0168 2.75003 10.8 2.75003H4C3.30964 2.75003 2.75 3.30967 2.75 4.00003C2.75 4.68746 3.30492 5.24529 3.99124 5.25H15.5L15.32 5.01003C14.5899 4.03659 14.3073 3.67112 13.9645 3.411C13.6435 3.16741 13.28 2.98564 12.8925 2.87498Z"
				fill="currentColor"
			/>
			<path
				d="M22.75 15.6359C22.75 15.8491 22.75 16.0536 22.7496 16.25H21C19.7574 16.25 18.75 15.2426 18.75 14C18.75 12.7574 19.7574 11.75 21 11.75H22.7496C22.75 11.9464 22.75 12.1509 22.75 12.3641V15.6359Z"
				fill="currentColor"
			/>
			<path
				d="M7.5 13.25C7.08579 13.25 6.75 13.5858 6.75 14C6.75 14.4142 7.08579 14.75 7.5 14.75H12.5C12.9142 14.75 13.25 14.4142 13.25 14C13.25 13.5858 12.9142 13.25 12.5 13.25H7.5Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
